/**
 * Restituisce l'eventuale label custom configurato sul widget (se non vuoto
 * dopo trim), altrimenti il defaultLabel tradotto.
 */
export function resolveCustomLabel(
  customLabel: string | undefined,
  defaultLabel: string,
): string {
  return customLabel && customLabel.trim().length > 0
    ? customLabel
    : defaultLabel;
}
